import { Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

import { AuthService } from './auth/auth.service';
import {UtilService} from './core/util/util.service'
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LoaderService } from './core/util/loader.service';
import { RedirectionService } from './core/redirection.service';
import { TokenService } from './core/token-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'owner-portal-angular';
  isLogin = false;
  userInfo:any;
  expires = new Date();
  refreshToken = this.authService.getToken('refreshToken');
  expireInterval = this.authService.getLocalStoarge('expireInterval');
  
  constructor(private tokenService: TokenService, private authService: AuthService,private utilService: UtilService,private router: Router,public translate: TranslateService, private titleService: Title, private loaderService: LoaderService, private redirectionService: RedirectionService){
    // ßconsole.log('route URL = ',this.router.url);
    // Inside your routing component or service
    this.userInfo = JSON.parse(this.authService.getLocalStoarge('userInfo') || '{}');
    if(this.router.url != 'changePassword'){
      this.utilService.checkLanguageConstraintForApp();
    }

    this.router.events.subscribe((event:any) => {
      this.isLogin = this.authService.isAuthenticated();
      if (event instanceof NavigationStart) {
        this.loaderService.show();
      } else if (event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loaderService.hide();
      } else if(event instanceof NavigationEnd){
        this.loaderService.hide();
        this.redirectionService.handleRedirection(event.urlAfterRedirects);
      }
    });
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.titleService.setTitle(event.translations.lang.page_title);
    });
    this.tokenService.startTokenRefresh();
  }

  checkSession(){
    this.authService.userSession()?.subscribe((session:any)=>{
      this.authService.setLocalStorage('sessionId',session.session_user_id);
      this.userAccount(session?.session_user_id)
    },
    (error) => {
      console.log(error.error);
      this.loaderService.hide();
    })
  }

  userAccount(sessionId : string){
    this.authService.userAccount(sessionId)?.subscribe((userInfo:any)=>{
      this.authService.setLocalStorage('userInfo',JSON.stringify(userInfo.account));
      let userDetails = JSON.parse(this.authService.getLocalStoarge('userInfo') || '{}');
      if(this.authService.checkUserRole(userDetails)){
        this.router.navigate([ 'owners-center']);
      } else if (userDetails?.userLevel == 'dev'){
        this.router.navigate([ 'engineering']);
      }
      this.loaderService.hide();
    },
    (error) => {
      console.log(error.error);
      this.loaderService.hide();
    })
  }



}
